/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Open_Crm_PropertyInputs */

const cs_ebr_open_crm_property = /** @type {(inputs: Ebr_Open_Crm_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitost v CRM`)
};

const en_ebr_open_crm_property = /** @type {(inputs: Ebr_Open_Crm_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open property in CRM`)
};

/**
* | output |
* | --- |
* | "Open property in CRM" |
*
* @param {Ebr_Open_Crm_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_open_crm_property = /** @type {((inputs?: Ebr_Open_Crm_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Open_Crm_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_open_crm_property(inputs)
	return cs_ebr_open_crm_property(inputs)
});